export const buildBrowserPhoneCdr = (cdr, context = null) => {
  if (!context) return cdr;

  return {
    ...cdr,
    ChatwootAccountId: context.accountId || null,
    ChatwootAgentId: context.agentId || null,
    ChatwootAgentName: context.agentName || null,
    ChatwootContactId: context.contactId || null,
    ChatwootConversationId: context.conversationId || null,
    ChatwootTriggerSource: context.source || null,
  };
};
